import { getTimeSuggestionsStore } from '../selectors/getTimeSuggestionsStore';
import { CalendarComponent } from 'owa-calendar-usage-instrumentation';

export default function getIsTimePanelView(viewStateId: string | null) {
    const { calendarComponent } = getTimeSuggestionsStore(viewStateId);
    return calendarComponent == CalendarComponent.MyDayPanelCompose;
}
